import ja from './ja.json'

export const defaultLocale = 'ja'

export const languages = {
  ja: ja
}
